var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inquiry_div"},[_c('ScrollToTopButton'),_c('iframe',{ref:"iframeContent",attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLSfHdx_blZkP2SAQ22t4SSzoUO-3zc-9dz10R6VJbgHmB6iQUA/viewform?embedded=true","width":"100%","height":"100%","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("読み込んでいます…")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }